import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { GET_TENANT } from '@src/util/query/tenant.query';
import { DEFAULT_CURRENCY } from '@src/util/currency/currency';

// The tenant's default currency (Settings → Preferences → Default Currency, stored as
// tenant.invoiceCurrency): what a new rate starts in, and what a rate saved before currencies were
// recorded is in. Same cached GET_TENANT read as useTenantFeatureFlags.
export function useDefaultCurrency() {
    const { authenticatedUserDetail } = useSelector(s => s.userAuthReducer);
    const tenantId = authenticatedUserDetail?.tenantId || localStorage.getItem('tenantId');

    const { data } = useQuery(GET_TENANT, {
        variables: { tenantId },
        skip: !tenantId,
        fetchPolicy: 'cache-first',
    });

    return data?.getTenant?.response?.invoiceCurrency || DEFAULT_CURRENCY;
}
